import * as Part from './part.models';
import * as PMNote from './pmNote.models';
import { IJobBackref } from './purchaseOrder.models';
import { BaseModel, EmptyBackReference, IBackReference, ISearchRequest } from './utility.models';
import { WorkflowStatus } from '@/models/workflow.models';

export interface IWorkOrderModel {
	id: string;
	name: string;
	number: string;
	date: Date;
	datePromised: Date;
	notes: string;
	projectManager: IBackReference | string;
	job: IJobBackref | string;
	customer: IBackReference | string;
	parts: Array<Part.IPartModel>;
	pmNotes: Array<PMNote.IPMNoteModel>;
	lifecycle: Array<WorkflowStatus>;
	priority: string;
	documents: Object;
	status: WorkflowStatus;
	css: string;
}

export interface IWorkOrderSearchRequest extends ISearchRequest {
	locationId: string;
}

// <editor-fold> Document models

export class WorkOrderModel implements IWorkOrderModel {
	id: string = null;
	name: string = null;
	number: string = null;
	date: Date = null;
	datePromised: Date = null;
	notes: string = null;
	projectManager: IBackReference = EmptyBackReference;
	job: IJobBackref = { _id: null, name: null, customer: null, projectManager: null };
	customer: IBackReference | string = null;
	parts: Array<Part.IPartModel> = new Array<Part.IPartModel>();
	pmNotes: Array<PMNote.IPMNoteModel> = new Array<PMNote.IPMNoteModel>();
	priority: string = 'None';
	documents: Object;
	lifecycle: Array<WorkflowStatus>;
	status: WorkflowStatus;
	css: string;

	constructor() {
		// trim read-only values
		delete this.customer;
	}
}

export function isIWorkOrder(obj: any): obj is IWorkOrderModel {
	return 'projectManager' in obj && 'pmNotes' in obj;
}

// </editor-fold>
